import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (process.env.NODE_ENV === 'production') {
  const u = String(supabaseUrl || '').trim();
  const okUrl = u.startsWith('https://');
  const okKey = typeof supabaseKey === 'string' && supabaseKey.length > 40;
  if (!okUrl || !okKey) {
    // anon 키만 사용. 누락·오설정 시 조기 실패(프로덕션 빌드는 반드시 env 주입).
    throw new Error('REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY 가 올바르지 않습니다.');
  }
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
  }
});